// Global CPV Label Map Store - Populated when CPVSelector fetches data
// Avoids duplicate API calls and shares the map across all components
// Automatically resets when language changes to allow refresh

class CpvLabelMapStore {
    constructor() {
        this.map = {};
        this.loading = false;
        this.callbacks = [];
        this.currentLanguage = null;
    }

    // Register callback to be called when map is updated
    onUpdate(callback) {
        this.callbacks.push(callback);
        return () => {
            // Return unsubscribe function
            this.callbacks = this.callbacks.filter(cb => cb !== callback);
        };
    }

    // Notify all subscribers
    notifyUpdate() {
        this.callbacks.forEach(cb => cb());
    }

    // Called by CPVSelector when it fetches CPV data
    populateFromTree(treeData, language) {
        // If language has changed, reset the map immediately
        if (language && language !== this.currentLanguage) {
            this.map = {};
            this.currentLanguage = language;
            // Notify immediately that we've changed language (even though map is empty)
            // This forces subscribers to re-render with empty map state
            this.notifyUpdate();
        }

        const traverse = (nodes) => {
            for (const node of nodes) {
                if (node.code && node.label) {
                    this.map[node.code] = node.label;
                }
                if (node.children?.length) {
                    traverse(node.children);
                }
            }
        };
        traverse(treeData);
        // Notify again after populating with new data
        this.notifyUpdate();
    }

    getLabel(code) {
        return this.map[code] || code;
    }

    getMap() {
        return this.map;
    }

    reset() {
        this.map = {};
        this.currentLanguage = null;
    }
}

export default new CpvLabelMapStore();